(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-search-form/assets/javascripts/casino-search-form.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-search-form/assets/javascripts/casino-search-form.js');
'use strict';

const {
  useState,
  useCallback,
  useEffect,
  useRef
} = React;
const {
  ReactIcon,
  ReactButton: Button
} = svs.ui;
const {
  Inputv2: Input,
  Form,
  ControlGroup
} = svs.ui.reactForm;
const {
  breakpoints,
  useMediaQuery,
  BREAKPOINT_AM
} = svs.components.lbUtils.useMediaQuery;
const {
  useSetSearchParams,
  useSearchParams
} = svs.components.casino_react.hooks;
const DEBOUNCE_INTERVAL = 500;
let trackSearchDelayer;
const trackSearchString = str => {
  clearTimeout(trackSearchDelayer);
  if (str && str.length > 1) {
    trackSearchDelayer = setTimeout(() => {
      svs.components.analytics.trackSearch(str, 'Casino');
    }, 2000);
  }
};
const CasinoSearchForm = () => {
  const {
    q: queryString
  } = useSearchParams();
  const [searchInputValue, setSearchInputValue] = useState(queryString);
  const {
    setQuery,
    clearParams
  } = useSetSearchParams();
  const debounceTimer = useRef(null);
  useEffect(() => {
    setSearchInputValue(queryString);
  }, [queryString]);
  const onInputChange = useCallback(e => {
    setSearchInputValue(e.target.value);
    if (e.target.value === '') {
      setQuery(e.target.value);
      return;
    }
    clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => {
      trackSearchString(e.target.value);
      setQuery(e.target.value);
    }, DEBOUNCE_INTERVAL);
    return () => clearTimeout(debounceTimer.current);
  }, [setQuery]);
  const isSmallDevice = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  return React.createElement(Form, {
    className: "casino-search-form",
    isVertical: !isSmallDevice,
    onSubmit: e => {
      e.preventDefault();
    }
  }, searchInputValue && React.createElement(Button, {
    "aria-label": "Rensa s\xF6k",
    className: "casino-search-form__button-reset-search",
    onClick: () => {
      setSearchInputValue('');
      clearParams();
    }
  }, React.createElement(ReactIcon, {
    icon: "menu-left",
    size: "300"
  })), React.createElement(ControlGroup, {
    className: "casino-search-form__control-group",
    v2: true
  }, React.createElement(Input, {
    autoComplete: "off",
    label: "S\xF6k",
    onChange: onInputChange,
    suffix: React.createElement(Button, {
      "aria-label": "S\xF6k efter: ".concat(searchInputValue ? searchInputValue : 'casino spel'),
      className: "casino-search-form__search-icon-wrapper"
    }, React.createElement(ReactIcon, {
      color: "navy",
      icon: "search",
      size: "100"
    })),
    type: "text",
    value: searchInputValue
  })));
};
setGlobal('svs.components.casino_react.casinoSearchForm.CasinoSearchForm', CasinoSearchForm);

 })(window);